import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
//
//import DeliveryLocations from './../Components/DeliveryLocations'
//
import AccountResources from './../Account/Resources/commonfunctions.js';

//
let service = new services();

export default {
    name: 'CreateAccount',
    mixins: [AccountResources],
    data () {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints:{},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error:false,
            group_isset:false,
            add_sellpoint: false,
            add_business: false,
            get_flag:false,
            loading:false,
            action_loading:false,

            //messages
            validate_user_name_message: "",
            payment_successful_message:"",
            data_error_message: "",
            data_boarding_message: "",
            //
            headerdata:{
                'name':'Create Your Order',
            }
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
       // 'component-delivery-locations': DeliveryLocations
    },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },

        preset() {
            this.loading = true;
            
            //../
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    localforage.getItem(service.bdb_name, function(err, value) { //quick with the callback version
                    if(value != undefined) {
                            self.sellpoint = value;
                            //get some core details
                            self.setBusinessDetails();
                            //get products
                            self.getSellpointProducts();
                        }else{
                            self.loading = false;
                        }
                    });
                }else {
                    self.loading = false;
                }
            });
            
        },

        setBusinessDetails(){
            //---bank-details
            let self = this;
            localforage.getItem(service.bbnksdb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {console.log(7654999)
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });
            //--delivery-locations
            localforage.getItem(service.bbdlsdb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });
        },

        set_checked(set){
            let done = true;
            
            //
            return done;
        },

},
created: function(){
    this.preset();
    //
    this.getRavepayBanks();
}
}



// WEBPACK FOOTER //
// ./src/pages/CreateAccount/script.js